/**
 * @description 防抖
 * @param {*} func
 * @param {*} wait
 */
function debounce(func, wait) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
/**
 * @description 获取接口域名
 * @param {*} func
 * @param {*} wait
 */
function getHost() {
  return 'https://official-manage.haier-ioc.com'
  // if (window.location.href.indexOf('https://official.haier-ioc.com') > -1){
  //   return 'https://official-manage.haier-ioc.com';
  // } else {
  //   return 'https://dev-yswl-website-front.haier-ioc.com';
  // }
}
export { debounce, getHost };
